import React, { useState } from 'react';
import { ProjectInfo } from './ProjectInfo';

export function ProjectList({ sites = [], selectedSite, onSelect }) {
  const [filter, setFilter] = useState('active');
  const visibleSites = sites.filter(site => (site.marketplaceStatus || 'active') === filter);
  return <>
    <div className="flex gap-1 rounded-lg bg-[#F4F5F9] p-1 w-[275px]" role="group" aria-label="Filter projects by status">
      {['active', 'paused'].map(status => <button key={status} type="button" aria-pressed={filter === status}
        onClick={() => setFilter(status)}
        className={`flex-1 rounded-md px-3 py-2 text-xs font-medium font-poppins ${filter === status ? 'bg-white text-[#344054] shadow-sm' : 'text-[#667085]'}`}>
        {status === 'active' ? 'Active' : 'Paused'} ({sites.filter(site => (site.marketplaceStatus || 'active') === status).length})
      </button>)}
    </div>
    {visibleSites.length ? visibleSites.map(site => <ProjectInfo key={site._id} site={site} selected={site._id === selectedSite?._id} onClick={() => onSelect(site)} />)
      : <p className="w-[275px] p-4 text-xs text-gray">No {filter} projects.</p>}
  </>;
}
